import React, { createContext, useContext, useState } from 'react'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'

type AppStateContextValues = {
  isWebWrapped?: boolean
  isCreditCard?: boolean
  // eslint-disable-next-line camelcase
  oaa_ole?: boolean
}

const AppStateContext = createContext<AppStateContextValues>(
  {} as AppStateContextValues,
)

export const useAppState = (): AppStateContextValues => {
  return useContext(AppStateContext)
}

interface AppStateProviderProps {
  children: React.ReactNode
}

export const AppStateProvider: React.FC<AppStateProviderProps> = ({
  children,
}) => {
  const [isWebWrapped, setIsWebWrapped] = useState(false)
  const [isCreditCard, setIsCreditCard] = useState(false)
  const [isOAAOLE, setIsOAAOLE] = useState(false)
  const location = useLocation()

  const params = queryString.parse(location.search, { parseBooleans: true })

  if (
    typeof params.isWebWrapped === 'boolean' &&
    params.isWebWrapped !== isWebWrapped
  ) {
    setIsWebWrapped(params.isWebWrapped)
  }

  if (
    Object.prototype.hasOwnProperty.call(params, 'creditcard') &&
    !isCreditCard
  ) {
    setIsCreditCard(true)
  }

  if (typeof params.oaa_ole === 'boolean' && params.oaa_ole !== isOAAOLE) {
    setIsOAAOLE(params.oaa_ole)
  }

  const initialValues = {
    isWebWrapped,
    isCreditCard,
    oaa_ole: isOAAOLE,
  }

  return (
    <AppStateContext.Provider value={initialValues}>
      {children}
    </AppStateContext.Provider>
  )
}
